import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { BrandingManagerService } from '@rx-applications/shared/branding/api';

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  #titleService = inject(Title);
  #router = inject(Router);
  readonly #brandingManager = inject(BrandingManagerService);
  navigationEndSub = this.#router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      if (!event.url.includes('book/hotels')) {
        this.setDefaultTitle();
      }
    });

  setDefaultTitle(): void {
    const defaultTitle = this.#brandingManager.getBrandAccess().getDefaultTitle();
    this.#titleService.setTitle(defaultTitle);
  }

  setTitle(title: string) {
    this.#titleService.setTitle(title);
  }
}
